/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getRulesetForState} from '../api'

 export const useQueryGetRulesetForState = createReactQueryHook('getRulesetForState', getRulesetForState)
